import { Button, Space } from "antd";
import { ReactNode } from "react";
import SuccessCheck from "../assets/icons/SuccessCheck";
import CustomModal from "../components/ui/CustomModal";

export interface ModalSuccessfulProps<
  DataT = never,
  TypeT = "SUCCESS" | "ADD" | "UPDATE" | "VIEW"
> {
  open: boolean;
  buttonBgDeep: boolean;
  handleClose: (val?: any) => void;
  type?: TypeT;
  data?: DataT;
  title?: ReactNode;
  subTitle?: ReactNode;
  buttonName?: string;
  handleButton: (val?: any) => void;
}

export default function SuccessfullyModalLayout({
  title,
  subTitle,
  buttonName,
  buttonBgDeep,
  handleButton,
  handleClose,
  type,
  data,
  ...rest
}: ModalSuccessfulProps) {
  return (
    <>
      <CustomModal
        {...rest}
        handleClose={handleClose}
        width={400}
        footer={null}
      >
        <div className="rounded flex justify-center">
          <SuccessCheck />
        </div>

        <div className="mt-3 justify-center text-center  text-zinc-700 text-xl font-semibold font-['Inter'] leading-9">
          {" "}
          {title}
        </div>

        <div className="my-2 text-[#5E718D] text-center">{subTitle}</div>

        <Space className="w-full mt-3 flex justify-center" size={12}>
          <Button
            onClick={handleButton}
            type="text"
            size="small"
            className={`w-14 px-3 py-1.5 ${
              buttonBgDeep === true ? `bg-orange-500` : `bg-orange-50`
            } rounded-md inline-flex justify-center items-center gap-2.5`}
          >
            <span
              className={`justify-start ${
                buttonBgDeep === true ? `text-white` : `text-orange-500`
              }  text-sm font-semibold font-['Inter'] leading-normal`}
            >
              {buttonName}
            </span>
          </Button>
        </Space>
      </CustomModal>
    </>
  );
}
